
import * as actionTypes from '../actions/actionTypes';

export default function currentActivationTabReducer(state = 0, action) {
  switch(action.type){
    case actionTypes.SET_LANDING_ACTIVE_TAB: {
      return action.activeTabId;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/landingTabReducer.js